import './FicheWebinar.scss';
import { useEffect, useState } from "react";
import { Image } from '../../../Image/Image';
import { FicheType } from '../../FicheType/FicheType';
import { GetThumbnail } from '../../../Popup/funcs';
export const FicheWebinar = (props) => {
    
    const [lightboxThumbnailUrl, setLightboxThumbnailUrl] = useState("");

    useEffect(() => {
        (async () => {
            if (props.data && props.data.video && props.data.video.url) {
                var thumbnail = await GetThumbnail(props.data.video.url);
                setLightboxThumbnailUrl(thumbnail);
            }
        })()

    }, [JSON.stringify(props.data.video)]);

    return (
        <div 
            className={` c-fiche c-webinar ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if(props.data?.hasDetail && props.openPopup){
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div className='webinair-thumbnail-container' style={{backgroundImage: `url("${lightboxThumbnailUrl}")`}}>
                <div className="play-button">
                    <i class="fa fa-play" aria-hidden="true"></i>
                </div>
                <FicheType type={props.data.type}>
                    <i class="fa-fw fa-fw fas fa-calendar-alt"></i>
                </FicheType>
                {props.data?.image?.url && (
                    <div className="image" title="Meer over">
                    <Image
                        alt={props.data.title}
                        src={props.data.image && props.data.image.url}
                    />
                    </div>
                )}
                <header className="c-fiche__header">
                    {props.data?.tagIcon?.url && (
                    <div className="c-tag-list">
                        <div className="c-tag corona" title="coronaproof">
                        <Image
                            alt={props.data.tagIcon.alt}
                            src={props.data.tagIcon.url}
                        />
                        </div>
                    </div>
                    )}                    
                    <h2 className="title" title={props.title}>
                    {props.data.title}
                    </h2>
                    <p>
                       {props.data.text}
                    </p>
                </header>          
            </div>
        </div>
    );
}